module.exports = __webpack_public_path__ + "static/bgTofu-d63c2bb62bd7295950dad8397169e42b.svg";